<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700&display=swap');
@import "~bootstrap/scss/bootstrap-reboot.scss";

.clearfix {
  clear: both;
}

body {
  background: #fff;
  color: #333334;

  &.dark {
    background: #19191a;
    color: #f8e5d8;
  }
}

#app {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
}
</style>
